<div class="distractor">
  <div
    class="distractor__circle"
    *ngIf="(circleSplash || circleText) && !circleIcon"
  >
    <strong *ngIf="circleSplash" [innerHTML]="circleSplash"></strong>
    <span *ngIf="circleText" [innerHTML]="circleText"></span>
  </div>

  <div
    class="distractor__circle"
    *ngIf="circleIcon"
    [style.transform]="'rotate(' + rotationDegrees + 'deg)'"
  >
    <hdi-icon
      [iconName]="circleIcon"
      [size]="Sizes.XLARGE"
      [color]="iconColor"
    />
  </div>

  <div class="distractor__content" *ngIf="text">
    <p [innerHTML]="text"></p>
    <hdi-link
      [label]="link.label | capitalize"
      [href]="link.href!"
      [type]="LinkType.BREADCRUMB"
      [color]="Colors.WHITE"
      *ngIf="link"
    />
  </div>
</div>
